__webpack_require__.p = "/Diagnosis-Migraine/";